import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminAuth } from '../utils/adminApi';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      // BYPASS: Always set authenticated for now
      console.log('BYPASS: Auth check bypassed - always authenticated');
      setIsAuthenticated(true);
      setAdmin('admin');
    } catch (error) {
      console.error('Auth verification failed:', error);
      setIsAuthenticated(false);
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (credentials) => {
    try {
      // BYPASS: Simple credential check without JWT
      if (credentials.username === 'admin' && credentials.password === 'admin123') {
        console.log('BYPASS: Simple auth - login successful');
        setIsAuthenticated(true);
        setAdmin(credentials.username);
        localStorage.setItem('adminToken', 'bypass-token'); // Set dummy token
        return { success: true, admin: credentials.username };
      } else {
        throw new Error('Invalid credentials');
      }
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = () => {
    adminAuth.logout();
    setIsAuthenticated(false);
    setAdmin(null);
  };

  const value = {
    isAuthenticated,
    loading,
    admin,
    login,
    logout,
    checkAuthStatus
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};

export default AdminContext;